const HealthComponent = () => {
  return (
    <div>
      Health is FINE.
    </div>
  );
};

export default HealthComponent;
